import { render, staticRenderFns } from "./RecruiterAiInterviewAgentListing.vue?vue&type=template&id=65960a24&scoped=true"
import script from "./RecruiterAiInterviewAgentListing.vue?vue&type=script&lang=ts"
export * from "./RecruiterAiInterviewAgentListing.vue?vue&type=script&lang=ts"
import style0 from "./RecruiterAiInterviewAgentListing.vue?vue&type=style&index=0&id=65960a24&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65960a24",
  null
  
)

export default component.exports